<app-header></app-header>

<!--============ Breadcumb ============= -->
<div class="breadcumb-wrapper" data-bg-src="assets/img/bg/breadcumb-bg.jpg">
    <div class="container">
        <div class="breadcumb-content">
            <h1 class="breadcumb-title">Logo Design</h1>
            <ul class="breadcumb-menu">
                <li><a routerLink="/">Home</a></li>
                <li>Logo Design</li>
            </ul>
        </div>
    </div>
</div>

<section class="space">
    <div class="container">
        <div class="row">
            <div class="col-xxl-8 col-lg-7">
                <div class="page-single">
                    <div class="service-img sv-details-img">
                        <img class="w-100" src="assets/img/service/sv-details.jpg" alt="Logo Design" />
                    </div>
                    <div class="page-content sv-content d-block">
                        <h2 class="box-title">Logo Design</h2>
                        <p class="box-text mb-30">At Xipe Tech, we create impactful logo designs that reflect your
                            brand’s identity, values, and vision. Our creative team blends innovation with strategic
                            thinking to deliver unique, memorable logos that leave a lasting impression.
                        </p>
                        <div class="sv-gallery-wrapper">
                            <div class="row gy-4">
                                <div class="col-6">
                                    <div class="sv-sm-img">
                                        <img class="w-100" src="assets/img/service/video-image-1.jpg.webp" alt="" />
                                    </div>
                                </div>
                                <div class="col-6 my-5">
                                    <h2 class="box-title">Key Features of Logo Design</h2>
                                    <p>Our logo designs are crafted with precision and creativity to make your brand
                                        stand out. Here’s what makes them exceptional:</p>
                                    <div class="checklist tick-checklist sv-details-list mb-40">
                                        <ul>
                                            <li>Unique & Custom Design</li>
                                            <li>High Versatility for all platforms</li>
                                            <li>Simplicity for easy recognition</li>
                                            <li>Scalability without losing quality</li>
                                            <li>Timeless appeal that lasts</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="row gy-4">
                                <div class="col-12">
                                    <p>We focus on
                                        designs that are visually appealing, versatile, and aligned with your business
                                        goals,
                                        ensuring your brand stands out in the market.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xxl-4 col-lg-5">
                <app-service-sidebar></app-service-sidebar>
            </div>
        </div>
    </div>
</section>

<!--======== Footer Section ========-->
<app-footer></app-footer>